import Member from 'iam/models/Member'
import { NotificationPreferences } from './dtos/notifications'
import { NotificationsAPIRoot } from './API'
import { Id } from 'types/definitions'
import { rethrowRequestError } from 'utils/error-util'

/**
 * Notification preferences store.
 */
export default class NotificationPreferencesStore {
  constructor(private api: NotificationsAPIRoot) {}

  /**
   * Gets the preferences for the member.
   *
   * @param member
   */
  async getPreferences(member: Member): Promise<NotificationPreferences> {
    return this.api.preferences
      .get({
        workspace_id: Id.assert(member.workspace.id),
        user_public_id: Id.assert(member.user.publicId),
      })
      .catch(rethrowRequestError)
  }

  /**
   * Saves the preferences for the member.
   *
   * @param member
   */
  async savePreferences(
    member: Member,
    preferences: NotificationPreferences,
  ): Promise<NotificationPreferences> {
    return this.api.preferences
      .patch(
        {
          workspace_id: Id.assert(member.workspace.id),
          user_id: Id.assert(member.user.publicId),
        },
        preferences,
      )
      .catch(rethrowRequestError)
  }
}
